var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialYoutube = function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8 8.05578C21.8 8.05578 21.6044 6.66781 21.005 6.05672C20.2444 5.25422 19.3919 5.25047 19.0012 5.20391C16.2025 5 12.0044 5 12.0044 5H11.9956C11.9956 5 7.7975 5 4.99875 5.20391C4.6075 5.25047 3.75563 5.25422 2.99437 6.05672C2.395 6.66797 2.2 8.05578 2.2 8.05578C2.2 8.05578 2 9.68609 2 11.3156V12.8439C2 14.4741 2.2 16.1037 2.2 16.1037C2.2 16.1037 2.395 17.4917 2.99437 18.1028C3.75563 18.9053 4.755 18.8802 5.2 18.9639C6.8 19.1187 12 19.1666 12 19.1666C12 19.1666 16.2025 19.1603 19.0012 18.9564C19.3919 18.9092 20.2444 18.9055 21.005 18.103C21.6044 17.4917 21.8 16.1039 21.8 16.1039C21.8 16.1039 22 14.4742 22 12.8439V11.3156C22 9.68609 21.8 8.05578 21.8 8.05578ZM9.935 14.6958L9.93437 9.03656L15.3381 11.8759L9.935 14.6958Z",
    fill: "#F0F1FA"
  })));
};
export default SvgSocialYoutube;